import SectionBox from "PFComponents/box/section_box";
import Modal from "PFComponents/modal/modal";
import { Button } from "PFCore/components/button";
import { getProfileName } from "PFCore/helpers/profile";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import { useOverbookingMessage } from "../helpers";
import YellowWarningIcon from "../yellow_warning_icon";
import css from "./modals.module.scss";

const ReviewBookingModal = ({ close, engagement, role, shortlistItem }) => {
  const { t } = useTranslation("auditPlanner");
  const overbookingMessage = useOverbookingMessage(role);
  const { profile } = shortlistItem;

  return (
    <Modal style={{ maxWidth: 700, margin: "0 auto" }} closeOnBackdropClick handleClose={close}>
      <SectionBox>
        <div className={css.modal}>
          <h3 className={css.title}>
            <YellowWarningIcon style={{ margin: 0 }} width={50} height={50} viewBox="0 0 20 20" />
            {t("modals.overbookingDetected")}
          </h3>
          <hr className={css.separator} />
          <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "nowrap" }}>
            <div>
              <div>{t("engagement")}</div>
              <div className={css.bold}>{engagement.name}</div>
            </div>
            <div>
              <div>{t("role")}</div>
              <div className={css.bold}>{role.name}</div>
            </div>
            <div>
              <div>{t("modals.resource")}</div>
              <div className={css.bold}>{getProfileName(profile)}</div>
            </div>
          </div>
          <hr className={css.separator} />
          <div className={css.text}>{overbookingMessage}</div>
          <div className={css.buttons} style={{ justifyContent: "end" }}>
            <Button text={t("close")} onClick={close} />
          </div>
        </div>
      </SectionBox>
    </Modal>
  );
};

ReviewBookingModal.propTypes = {
  close: PropTypes.func.isRequired,
  engagement: PropTypes.object.isRequired,
  match: PropTypes.object,
  role: PropTypes.object.isRequired,
  shortlistItem: PropTypes.object.isRequired
};

export default ReviewBookingModal;
